import React from 'react'

const TVIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="tvGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(140, 180, 220, 1)" />
          <stop offset="100%" stopColor="rgba(100, 140, 180, 1)" />
        </linearGradient>
        <filter id="tvGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* TV screen */}
      <rect 
        x="3" 
        y="5" 
        width="18" 
        height="12" 
        rx="2"
        stroke="url(#tvGradient)"
        strokeWidth="2"
        fill="none"
        filter="url(#tvGlow)"
      />
      
      {/* Screen content */}
      <rect 
        x="5" 
        y="7" 
        width="14" 
        height="8" 
        fill="url(#tvGradient)"
        opacity="0.3"
      />
      
      {/* TV stand */}
      <path 
        d="M8 17h8M10 21h4"
        stroke="url(#tvGradient)"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line 
        x1="12" 
        y1="17" 
        x2="12" 
        y2="21" 
        stroke="url(#tvGradient)"
        strokeWidth="2"
      />
      
      {/* Antenna */}
      <line 
        x1="12" 
        y1="5" 
        x2="9" 
        y2="2" 
        stroke="url(#tvGradient)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line 
        x1="12" 
        y1="5" 
        x2="15" 
        y2="2" 
        stroke="url(#tvGradient)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default TVIcon
